

import * as Card from "../../toolkit/Card.bs.js";
import * as Head from "../../components/head/Head.bs.js";
import * as I18n from "../../i18n/I18n.bs.js";
import * as $$Text from "../../toolkit/Text.bs.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Route from "../../Route.bs.js";
import * as Stack from "../../toolkit/Stack.bs.js";
import * as React from "react";
import * as Button from "../../toolkit/Button.bs.js";
import * as Layout from "../../layout/Layout.bs.js";
import * as Network from "../../Network.bs.js";
import * as Belt_Option from "bs-platform/lib/es6/belt_Option.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as CatsPage_Css from "./CatsPage_Css.bs.js";
import * as LinearProgress from "../../components/mui/LinearProgress/LinearProgress.bs.js";
import * as LimitedWidthContainer from "../../toolkit/LimitedWidthContainer.bs.js";

function tr(translationPath) {
  return I18n.t(Route.toCode(/* Cats */3) + ("." + translationPath));
}

var catUrl = "/api/cat";

function CatsPage$Generator(Props) {
  var generateButtonText = tr("body.generate_button_text");
  var loadingButtonText = tr("body.loading_button_text");
  var result = tr("body.result");
  var match = React.useState((function () {
          return /* Init */0;
        }));
  var setStatus = match[1];
  var status = match[0];
  var fetchCatImage = function (param) {
    Curry._1(setStatus, (function (param) {
            return /* Fetching */1;
          }));
    var __x = Network.getBlob(catUrl);
    __x.then((function (file) {
            Curry._1(setStatus, (function (param) {
                    return /* Finished */[file];
                  }));
            return Promise.resolve(undefined);
          }));
    
  };
  React.useEffect((function () {
          fetchCatImage(undefined);
          
        }), ([]));
  var buttonLabel = typeof status === "number" && status !== 0 ? loadingButtonText : generateButtonText;
  var tmp;
  if (typeof status === "number") {
    tmp = status !== 0 ? React.createElement(LinearProgress.make, { }) : null;
  } else {
    var mbImage = status[0];
    if (mbImage !== undefined) {
      var url = URL.createObjectURL(Caml_option.valFromOption(mbImage));
      tmp = React.createElement(Stack.make, {
            gap: /* Sm */1,
            children: null
          }, React.createElement($$Text.Div.make, {
                children: result
              }), React.createElement("img", {
                className: CatsPage_Css.catImage,
                src: url
              }));
    } else {
      tmp = null;
    }
  }
  return React.createElement(LimitedWidthContainer.make, {
              maxWidth: /* Px840 */2,
              fullWidthMobile: true,
              children: React.createElement(Stack.make, {
                    gap: /* Lg */3,
                    children: null
                  }, React.createElement(Button.make, {
                        label: buttonLabel,
                        disabled: status === /* Fetching */1,
                        onClick: (function (param) {
                            return fetchCatImage(undefined);
                          })
                      }), React.createElement(Card.make, {
                        children: tmp
                      }))
            });
}

var Generator = {
  make: CatsPage$Generator
};

function CatsPage(Props) {
  var pageContext = Props.pageContext;
  var locale = Belt_Option.getWithDefault(pageContext.locale, "en");
  I18n.changeLanguage(locale);
  var title = tr("head.title");
  var description = tr("head.description");
  var h1Text = tr("body.h1");
  var h2Text = tr("body.h2");
  return React.createElement(React.Fragment, undefined, React.createElement(Head.make, {
                  title: title,
                  description: description,
                  lang: locale,
                  route: /* Cats */3
                }), React.createElement(Layout.make, {
                  route: /* Cats */3,
                  locale: locale,
                  children: null
                }, React.createElement($$Text.H1.make, {
                      align: /* center */98248149,
                      children: h1Text
                    }), React.createElement($$Text.H2.make, {
                      align: /* center */98248149,
                      children: h2Text
                    }), React.createElement(CatsPage$Generator, { })));
}

var Css;

var route = /* Cats */3;

var make = CatsPage;

var $$default = CatsPage;

export {
  Css ,
  route ,
  tr ,
  catUrl ,
  Generator ,
  make ,
  $$default ,
  $$default as default,
  
}
/* Card Not a pure module */
